import { ERRORS } from "../../../../../constants/errors";
import { dateRange } from "./dateRange";
import { email } from "./email";
import { postcode } from "./postcode";
import { list } from "./list";
import { percentages } from "./percentages";
import { range } from "./range";
import { regex } from "./regex";
import { tel } from "./tel";
import { zipcode } from "./zipcode";
import { getErrorMessage } from "../getErrorMessage";
import type { Validator } from "./types";

export { getErrorMessage };

export const ok = (name: string) => ({
  id: name,
  valid: true,
  message: undefined,
});

export const validators = {
  range,
  list,
  regex,
  email,
  postcode,
  tel,
  date: dateRange,
  percentages,
  zipcode,
};

export const applyRules: Validator = ({
  name,
  validation,
  answer,
  locale,
  questionErrorMessage,
}) => {
  if (!answer) {
    return {
      id: name,
      valid: false,
      message: getErrorMessage({
        questionErrorMessage,
        fallbackMessage: ERRORS.REQUIRED,
      }),
    };
  }

  const { type } = validation;

  if (!(type in validators)) {
    return ok(name);
  }

  const validator = validators[type];

  return validator({ name, validation, answer, locale, questionErrorMessage });
};
